<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Clientes</h4>
            <div class="small text-muted">Adminsitración de todos los clientes que interactuan con el software</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col sm="6" md="6" lg="4">
              <Widget :configWidget="configWidget" reference="indicator_total_customers" :hasAccess="configWidget.elements.indicatorTotalCustomers" />                          
              <Widget :configWidget="configWidget" reference="pie_origen_customers" :hasAccess="configWidget.elements.pieOrigenCustomers" />
              <Widget :configWidget="configWidget" reference="list_customers_email_repeat" :hasAccess="configWidget.elements.listCustomersEmailRepeat" v-if="parameters.validEmailRepeat" />
              <Widget :configWidget="configWidget" reference="list_customers_without_access" :hasAccess="configWidget.elements.listCustomersWithoutAccess" />
            </b-col>       
            <b-col sm="6" md="6" lg="8">
              <Widget :configWidget="configWidget" reference="list_last_customers" :hasAccess="configWidget.elements.listLastCustomers" />                            
              <Widget :configWidget="configWidget" reference="list_last_customers_editing" :hasAccess="configWidget.elements.listLastCustomersEditing" />                                          
            </b-col>                    
          </b-row>
        </b-col>  
        <b-col lg="3">
          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCustomers()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Clientes</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Adminsitración del clientes
              </p>
            </b-list-group-item>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openGroups()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Grupos de Clientes</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Administración de grupos
              </p>
            </b-list-group-item>
          </b-list-group>                     
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import Param from '@/config/parameters'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.CLIENTES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.CLIENTES,
          profile_id: Profiles.PERSONAL,
          elements: {             
            indicatorTotalCustomers: true,      
            pieOrigenCustomers: true,
            listCustomersEmailRepeat: true, 
            listCustomersWithoutAccess: true,
            listLastCustomers: true,     
            listLastCustomersEditing: true,                             
          }
        },
        parameters: {
          validEmailRepeat: Helper.hasParametersAccess(Param.P32),
        },        
        primaryColor: '',
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */
      this.configWidget.elements.indicatorTotalCustomers = Helper.hasAccessWidget(this.configWidget, 'indicator_total_customers')   
      this.configWidget.elements.pieOrigenCustomers = Helper.hasAccessWidget(this.configWidget, 'pie_origen_customers')   
      this.configWidget.elements.listCustomersEmailRepeat = Helper.hasAccessWidget(this.configWidget, 'list_customers_email_repeat')
      this.configWidget.elements.listCustomersWithoutAccess = Helper.hasAccessWidget(this.configWidget, 'list_customers_without_access')
      this.configWidget.elements.listLastCustomers = Helper.hasAccessWidget(this.configWidget, 'list_last_customers')      
      this.configWidget.elements.listLastCustomersEditing = Helper.hasAccessWidget(this.configWidget, 'list_last_customers_editing')      
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openCustomers() {
        this.$router.push({ name: 'CustomerListStaff' })
      },
      openGroups() {
        this.$router.push({ name: 'CustomerGroupsStaff' })
      },
    }    
   
  }
</script>

<style>

</style>
